// Theme management: light / dark / auto, persisted, toggleable.
import { ref } from 'vue'

export type ThemeMode = 'light' | 'dark' | 'auto'

const STORAGE_KEY = 'theme-mode'
export const themeMode = ref<ThemeMode>((localStorage.getItem(STORAGE_KEY) as ThemeMode) || 'light')

function systemPrefersDark(): boolean {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function isDark(): boolean {
  if (themeMode.value === 'auto') return systemPrefersDark()
  return themeMode.value === 'dark'
}

function apply() {
  document.documentElement.classList.toggle('dark', isDark())
}

export function setTheme(mode: ThemeMode) {
  themeMode.value = mode
  localStorage.setItem(STORAGE_KEY, mode)
  apply()
}

export function toggleTheme() {
  setTheme(isDark() ? 'light' : 'dark')
}

export function initTheme() {
  apply()
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      if (themeMode.value === 'auto') apply()
    })
  }
}
